import React from 'react'

function StudentReport() {
  return (
    <div>StudentReport</div>
  )
}

export default StudentReport